const reportWebVitals = onPerfEntry => {
  // Web vitals tracking disabled - package removed to reduce bundle size
  // To enable, install web-vitals and uncomment below:
  /*
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
  */
};

export default reportWebVitals;
